import { render, staticRenderFns } from "./IRModuleDevice.vue?vue&type=template&id=33cca54f&scoped=true&"
import script from "./IRModuleDevice.vue?vue&type=script&lang=js&"
export * from "./IRModuleDevice.vue?vue&type=script&lang=js&"
import style0 from "./IRModuleDevice.vue?vue&type=style&index=0&id=33cca54f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cca54f",
  null
  
)

export default component.exports